export class SlugService {
    getDetailsPageUrlByContentId(contentId, slug) {
        return `${slug}/${contentId}/details`;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/slug/slug.service.js